import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges,
} from '@angular/core';
import { FormControl } from '@angular/forms';
import { IntervalType, SlotListArray, TimeSlot } from '@checkout/const';
import { Subscription } from 'rxjs';

@Component({
  selector: 'sd-time-slot-groups',
  templateUrl: './time-slot-groups.component.html',
  styleUrls: ['./time-slot-groups.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SdvorTimeSlotGroupsComponent implements OnInit, OnChanges, OnDestroy {
  @Input() currentTimeSlot: TimeSlot | null;
  @Input() slotListArray: SlotListArray;

  @Output() selectTimeSlot = new EventEmitter<TimeSlot | undefined>();

  intervalType = IntervalType;
  intervalTypeControl = new FormControl();

  private subscription = new Subscription();

  constructor() {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.slotListArray || changes.currentTimeSlot) {
      this.intervalTypeControl.patchValue(this.currentTimeSlot?.intervalType || null);
    }
  }

  ngOnInit(): void {
    this.subscription.add(
      this.intervalTypeControl.valueChanges.subscribe((intervalType: IntervalType) => {
        if (
          this.currentTimeSlot &&
          this.currentTimeSlot.date === this.slotListArray.groups[intervalType][0].date &&
          this.currentTimeSlot.intervalType === intervalType
        ) {
          return;
        }

        if (this.slotListArray.groups[intervalType]) {
          this.selectTimeSlot.emit(this.slotListArray.groups[intervalType][0]);
        }
      }),
    );

    const singleDeliveryType = this.singleDeliveryType(this.slotListArray);
    if (singleDeliveryType) {
      this.intervalTypeControl.setValue(singleDeliveryType);
    }
  }

  singleDeliveryType(slotListArray: SlotListArray): IntervalType {
    const groups = Object.values(slotListArray.groups);

    const noEmptyGroup = groups.findIndex((group) => group.length > 0);

    if (noEmptyGroup === -1 || groups.slice(noEmptyGroup + 1).some((group) => group.length > 0)) {
      return null;
    }

    return Object.keys(slotListArray.groups)[noEmptyGroup] as IntervalType;
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  // вот что бывает, когда нет ИД.
  isTimeSlotActive(timeSlot: TimeSlot | undefined): boolean {
    return this.currentTimeSlot
      ? timeSlot.price === this.currentTimeSlot.price &&
          timeSlot.intervalType === this.currentTimeSlot.intervalType &&
          timeSlot.deliveryType === this.currentTimeSlot.deliveryType &&
          timeSlot.interval === this.currentTimeSlot.interval &&
          timeSlot.date === this.currentTimeSlot.date
      : false;
  }

  timeSlotActiveIndex(timeSlots: TimeSlot[]): number {
    return timeSlots.findIndex((slot) => this.isTimeSlotActive(slot));
  }

  justInTimeTimeSlots(timeSlots: TimeSlot[]): TimeSlot[] {
    timeSlots.forEach((timeSlot: TimeSlot) => {
      const beginning = timeSlot.interval.split(' - ')[0];
      timeSlot.intervalDisplay = beginning;
      timeSlot.interval = `${beginning} - ${beginning}`;
    });

    return timeSlots;
  }
}
